import { IconButton, InputLabel, makeStyles, Theme } from "@material-ui/core";
import AddCircleOutline from "@material-ui/icons/AddCircleOutline";
import { Editor } from "./Editor";
import React, { useEffect, useState } from "react";
import { Spacer } from "@internal/plugin-utilities";
import { ReviewManualDetailsDBResponse } from "@internal/plugin-ops-review-common";

const useStyles = makeStyles((_theme: Theme) => ({
  label: {
    marginBottom: "10px",
  },
}));

export interface Props {
  data: ReviewManualDetailsDBResponse;
  setUpstreamData: React.Dispatch<
    React.SetStateAction<React.MutableRefObject<any>>[]
  >;
  submitRef: React.MutableRefObject<any>;
}

export const FreeformSection: React.FC<Props> = ({
  data,
  setUpstreamData,
  submitRef,
}: Props): JSX.Element => {
  const classes = useStyles();

  const [freeform, setFreeform] = useState<string[]>([]);
  const [freeformStructure, setFreeformStructure] = useState<JSX.Element[]>([]);
  const [refs, setRefs] = useState<React.MutableRefObject<any>[]>([]);

  useEffect(() => {
    if (data) {
      setFreeform(data.freeform);
    }
  }, [data, setFreeform]);

  useEffect(() => {
    const ff = freeform.map((val: string) => {
      return <Editor refs={refs} setRefs={setRefs} initialValue={val} />;
    });
    setFreeformStructure(ff);
    setUpstreamData(refs);
  }, [freeform, refs, setUpstreamData]);

  const [jsx, setJsx] = useState<JSX.Element>();

  useEffect(() => {
    const li = freeformStructure.map((editor: JSX.Element, idx: number) => {
      return (
        <li key={`freeform-${idx}`}>
          <>
            {editor}
            <Spacer variant="double" />
          </>
        </li>
      );
    });
    setJsx(<ul style={{ padding: 0, listStyle: "none" }}>{li}</ul>);
  }, [freeformStructure]);

  const handleAddFreeformClick = () => {
    const newFreeform = freeform.slice();
    newFreeform.push("");
    setFreeform(newFreeform);
    setTimeout(
      () =>
        submitRef.current.scrollIntoView({
          behavior: "smooth",
          block: "end",
          inline: "end",
        }),
      100
    );
  };

  return (
    <>
      <InputLabel className={classes.label}>
        Want to talk about something else? Add a freeform section to the
        OpsReview:{" "}
        <IconButton onClick={handleAddFreeformClick}>
          <AddCircleOutline />
        </IconButton>
      </InputLabel>
      {jsx}
    </>
  );
};
